module.exports = "https://cdn.realtymogul.com/static/media/social_fb_blue.db0abd18.svg";